import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFileInfo } from './index';
import { checkFileExtension, checkFileIsImage, checkFileSize, uploadFile as _uploadFile } from './upload';
export default {
  name: 'UpLoadIndex',
  props: {
    linkUrl: {
      type: Object,
      default: Object
    },
    limit: {
      type: Number,
      default: 5
    },
    imgList: {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
      fileTypeList: [],
      sizeLimit: 0
    };
  },
  watch: {
    linkUrl: {
      handler: function handler() {
        this.$store.dispatch('app/linkUrl', this.linkUrl);
      },
      immediate: true
    }
  },
  created: function created() {
    this.getUploadInfo();
  },
  methods: {
    clearFile: function clearFile() {
      this.$refs['el-upload'].clearFiles();
    },
    handleExceed: function handleExceed() {
      this.$message.warning('上传文件超出限制');
    },
    handleRemove: function handleRemove(file, fileList) {
      var index = this.fileList.findIndex(function (item) {
        return item === file.uid;
      });
      this.fileList.splice(index, 1);
      this.$emit('delImgIndex', index);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 获取图片上传类型等
    getUploadInfo: function getUploadInfo() {
      var _this = this;
      getFileInfo().then(function (res) {
        _this.fileTypeList = res.data.file_allow_extensions;
        _this.sizeLimit = res.data.file_size_limit;
      });
    },
    // 上传前的函数 //上传前对图片类型和大小进行判断
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var extensions = this.fileTypeList;
      var size = this.sizeLimit / 1024;
      if (!checkFileIsImage(file) || !checkFileExtension(file, extensions)) {
        var msg = '只能上传' + extensions.toString();
        this.$message.error(msg);
        return false;
      } else if (!checkFileSize(file, size)) {
        var msgError = "\u8BF7\u4E0A\u4F20".concat(size, "M\u4EE5\u5185\u7684\u56FE\u7247");
        this.$message.error(msgError);
        return false;
      }
    },
    uploadFile: function uploadFile(param) {
      var _this2 = this;
      var file = param.file;
      this.title = file.name;
      _uploadFile(file).then(function (response) {
        if (response.status === 200) {
          _this2.fileList.push(file.uid);
          _this2.$emit('emitUploadFile', response.config.key, URL.createObjectURL(file), param.file.name);
        } else {
          var error = new Error('后台错误信息：' + response.msg);
          return Promise.reject(error);
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$notify.error({
          title: '错误',
          message: '上传失败！',
          duration: _this2.notifyTime
        });
      });
    }
  }
};